module.exports = __webpack_public_path__ + "img/arrow-down.63532253.svg";